import {fileExtension} from "../constants/regexPatterns";

export const getFileExtension = (fileName) =>
    fileName.match(fileExtension)?.[0] || ""; 